export default class Grid {
  constructor(el) {
    this.el = el;

    const triggers = el.querySelectorAll('[data-grid-item-trigger]');

    if (window.screen.width > 640) {
      triggers.forEach((trigger) => {
        trigger.addEventListener(
          'click',
          this.handleDesktopClicks.bind(event, el)
        );
      });
    } else {
      triggers.forEach((trigger) => {
        trigger.addEventListener(
          'click',
          this.handleMobileClicks.bind(event, el)
        );
      });
    }
  }

  handleMobileClicks(el, event) {
    const trigger = event.target;
    const content = trigger.nextElementSibling;
    const activeClass = 'is-active';
    const hiddenClass = 'hidden';

    trigger.classList.toggle(activeClass);

    if (!content.style.maxHeight) {
      content.classList.remove(hiddenClass);
      content.style.maxHeight = '1000px';
    } else {
      content.style.maxHeight = null;
      content.classList.add(hiddenClass);
    }
  }

  handleDesktopClicks(el, event) {
    const headerEl = document.querySelector('[data-header]');
    const columns = window.screen.width < 1024 ? 2 : 4;
    const triggers = el.querySelectorAll('[data-grid-item-trigger]');
    const trigger = event.target;
    const content = trigger.nextElementSibling;
    const clonedContent = content.cloneNode(true);
    const gridItems = el.querySelectorAll('[data-grid-item]');
    const c =
      Array.from(trigger.parentNode.parentNode.children).indexOf(
        trigger.parentNode
      ) + 1;
    const rowPos = Math.ceil(c / columns) * columns;
    const existingPanel = el.querySelector('[data-grid-item-content]');
    const activeClass = 'is-active';
    let delay = 0;

    event.preventDefault();

    if (existingPanel) {
      existingPanel.style.maxHeight = '0px';
      delay = 500;

      setTimeout(() => {
        existingPanel.remove();
      }, 500);
    }

    setTimeout(() => {
      clonedContent.setAttribute('data-grid-item-content', true);

      if (!trigger.classList.contains(activeClass)) {
        window.scrollTo({
          left: 0,
          top: trigger.offsetTop - headerEl.getBoundingClientRect().height - 16,
          behavior: 'smooth',
        });
        triggers.forEach((trigger) => trigger.classList.remove(activeClass));
        trigger.classList.add(activeClass);

        gridItems[
          rowPos > gridItems.length ? gridItems.length - 1 : rowPos - 1
        ].after(clonedContent);

        setTimeout(() => {
          clonedContent.style.maxHeight = '2000px';
        }, 50);
      } else {
        trigger.classList.remove(activeClass);
        clonedContent.remove();
      }
    }, delay);
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/Grid.js